import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import { Toaster } from "@/components/ui/sonner";
import { CircleNotch } from "@phosphor-icons/react";
import Login from "@/pages/Login";
import Tournaments from "@/pages/Tournaments";
import TournamentDetail from "@/pages/TournamentDetail";
import Chat from "@/pages/Chat";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Pokerians from "@/pages/Pokerians";
import Rules from "@/pages/Rules";
import "@/App.css";

function Loading() {
  return <div className="min-h-screen flex items-center justify-center"><CircleNotch size={40} className="animate-spin text-primary" /></div>;
}

function Protected({ children, adminOnly }) {
  const { user, ready, isAdmin } = useAuth();
  const location = useLocation();
  if (!ready) return <Loading />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return <AppShell>{children}</AppShell>;
}

function AppRoutes() {
  const { user, ready } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={ready && user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Tournaments /></Protected>} />
      <Route path="/tournament/:id" element={<Protected><TournamentDetail /></Protected>} />
      <Route path="/chat" element={<Protected><Chat /></Protected>} />
      <Route path="/pokerians" element={<Protected><Pokerians /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/rules" element={<Protected><Rules /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
